module.exports = __webpack_public_path__ + "static/img/led_difuso_vermelho_3mm-1.3ec336f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_vermelho_3mm-1.svg
// module id = AMmb
// module chunks = 0